import { startVirtualPackageDownloader, getVirtualPackageDownloader } from '../tools/virtualPackageSyncer';
import { sleep, isIOS } from './helpers';
import { logger, initNativeLogging } from './logger';
import { BLUETOOTH_ENABLE_RESULT } from '../tools/consts';
import store from '../store'
let callID = 0;
const resolverMap = new Map();
window.nativeOnMessage = callResult => {
	const resolver = resolverMap.get(callResult.id);
	if (resolver) {
		/**
		if (resolver.method !== callResult.method) {
			console.error(
				`interfaceNative: nativeOnMessage: resolvers method ${resolver.method} is not matching ${callResult.method}`
			);
		} **/
		resolverMap.delete(callResult.id);
		resolver.resolve(callResult.result);
	} else {
		console.error('interfaceNative: nativeOnMessage could not find resolver', resolver);
	}
};
export function nativeMethodCall(_options = {}) {
	const options = Object.assign(
		{
			resultTransform: result => result,
		},
		_options
	);
	return new Promise(resolve => {
		if (window.nativeInterface && typeof window.nativeInterface[options.method] === 'function') {
			if (options.params)
				resolve(options.resultTransform(window.nativeInterface[options.method](...options.params)));
			else resolve(options.resultTransform(window.nativeInterface[options.method]()));
		} else if (
			window.webkit &&
			window.webkit.messageHandlers &&
			window.webkit.messageHandlers.nativeInterface &&
			window.webkit.messageHandlers.nativeInterface
		) {
			const jsonRPCObject = {
				method: options.method,
				params: options.params,
				id: ++callID,
			};
			// logger.log('interfaceNative: nativeMethodCall: RPCObject', jsonRPCObject);
			resolverMap.set(
				jsonRPCObject.id,
				Object.assign(jsonRPCObject, { resolve: result => resolve(options.resultTransform(result)) })
			);
			window.webkit.messageHandlers.nativeInterface.postMessage(JSON.parse(JSON.stringify(jsonRPCObject)));
		} else {
			logger.log(`Warning: ${options.method} not implemented`);

			/* eslint-disable no-nested-ternary */
			return resolve(
				options.fallback
					? options.params
						? options.fallback(...options.params)
						: options.fallback()
					: undefined
			);
		}
	}); // list is newline-separated
}

export const init = async waitForNative => {
	logger.log('native Interface not up wait for it!', waitForNative);
	if (waitForNative) {
		while (
			!window.nativeInterface &&
			!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeInterface)
		) {
			// Always show this warning even if loggs are off
			// since this is an endless loop that might not finish.
			console.warn('native Interface not up wait for it!');
			await sleep(100);
		}
		if (process.env.NODE_ENV === 'production') initNativeLogging();
	}
};

export const appStartOfflineAppSync = listOfApps =>
	nativeMethodCall({
		method: 'nativeAppStartOfflineAppSync',
		params: [JSON.stringify(listOfApps)],
		fallback: () => (store.state.isVirtualPackageSyncer ? startVirtualPackageDownloader(listOfApps) : undefined),
	});
// list is newline-separated
export const appGetOfflineApps = () =>
	nativeMethodCall({
		method: 'nativeAppGetOfflineApps',
		resultTransform: apps => (apps ? apps.split('\n').map(entry => ({ name: entry, version: -1 })) : null),
	});
export const appGetOfflineAppsWithVersion = () => {
	return nativeMethodCall({
		method: 'nativeAppGetOfflineAppsWithVersion',
		resultTransform: apps => {
			return apps ? JSON.parse(apps) : null;
		},
		fallback: () => (store.state.isVirtualPackageSyncer ? getVirtualPackageDownloader() : undefined),
	});
};
export const vRShowVideoMono = monoVideoURI =>
	nativeMethodCall({
		method: 'nativeVRShowVideoMono',
		params: monoVideoURI,
		fallback: () => false,
	});
export const wifiReassoc = () => nativeMethodCall({ method: 'nativeWifiReassoc' });
export const appGetLog = bytes =>
	nativeMethodCall({
		method: 'nativeAppGetLog',
		params: bytes,
	});
export const appNeedsVolumeControl = () =>
	nativeMethodCall({
		method: 'nativeAppNeedsVolumeControl',
		fallback: () => false,
	});
export const batteryGetState = () =>
	nativeMethodCall({
		method: 'nativeBatteryGetState',
		transform: state => {
			if (new RegExp('"discharging').test(state) || new RegExp('^discharging').test(state)) {
				return 'discharging';
			}
			if (new RegExp('"charging').test(state) || new RegExp('^charging')) return 'charging';
			if (new RegExp('full').test(state)) return 'full';
			return 'unknown';
		},
		fallback: () => 'unknown',
	});
export const batteryGetLevel = () =>
	nativeMethodCall({
		method: 'nativeBatteryGetLevel',
		fallback: () => -1,
	});
export const augmentedRealityStart = jsonMarkerModelList =>
	nativeMethodCall({
		method: 'nativeARStart',
		params: [jsonMarkerModelList],
		fallback: () => false,
	});
export const augmentedRealityGetVersion = () =>
	nativeMethodCall({
		method: 'nativeARGetVersion',
		transform: version => {
			if (!version) return undefined;
			return version;
		},
	});
export const appStartOfflineAppCheck = () =>
	nativeMethodCall({
		method: 'nativeAppStartOfflineAppCheck',
	});
export const audioMute = state =>
	nativeMethodCall({
		method: 'nativeAudioMute',
		params: [state],
	});
export const audioCrankUp = state =>
	nativeMethodCall({
		method: 'nativeAudioCrankUp',
		params: [state],
	});
export const vRShowMono = monoImageURI =>
	nativeMethodCall({
		method: 'nativeVRShowMono',
		params: [monoImageURI],
		fallback: () => false,
	});
export const infoGetDeviceName = () =>
	nativeMethodCall({
		method: 'nativeInfoGetDeviceName',
		fallback: () => 'unkown',
	});
export const infoGetModel = () =>
	nativeMethodCall({
		method: 'nativeInfoGetModel',
		fallback: () => 'unkown',
	});
export const appGetVersion = () => {
	logger.log('Do nativeAppGetVersion');
	return nativeMethodCall({
		method: 'nativeAppGetVersion',
		fallback: () => 'unkown',
	});
};
export const appPreventSleep = toggle =>
	nativeMethodCall({
		method: 'nativeAppPreventSleep',
		params: [toggle],
	});
export const appGoBack = () =>
	nativeMethodCall({
		method: 'nativeAppGoBack',
	});
export const appExit = restart =>
	nativeMethodCall({
		method: 'nativeAppExit',
		params: [!!restart],
	});
export const appGetIsLoaner = () =>
	nativeMethodCall({
		method: 'nativeAppGetIsLoaner',
		fallback: () => false,
	});
export const appIsIOS = () =>
	nativeMethodCall({
		method: 'nativeIsIOSApp',
		transform: os => !!os && isIOS(),
		fallback: () => false,
	});
export const contentShare = url =>
	nativeMethodCall({
		method: 'nativeContentShare',
		params: [url],
		fallback: url => console.log('native share url:' + url),
	});
export const contentShareText = text =>
	nativeMethodCall({
		method: 'nativeContentShareText',
		params: [text],
		fallback: text => console.log('native share text:' + text),
	});
export const contentOpen = url =>
	nativeMethodCall({
		method: 'nativeContentOpen',
		params: [url],
		fallback: result => {
			if (result.match(/^mailto:/)) window.location.href = result;
			else window.open(result);
		},
	});
export const contentDownload = url =>
	nativeMethodCall({
		method: 'nativeContentDownload',
		params: [url],
		fallback: result => {
			logger.log('Warning: nativeContentOpen not implemented');
			document
				.createElement('a')
				.setAttribute('href', result)
				.setAttribute('download', '')
				.click();
			return true;
		},
	});
export const appGetExhibitionID = () =>
	nativeMethodCall({
		method: 'nativeAppGetExhibitionID',
	});
export const infoGetAPIVersion = () =>
	nativeMethodCall({
		method: 'nativeInfoGetAPIVersion',
		fallback: () => 0,
	});
export const infoGetOS = () =>
	nativeMethodCall({
		method: 'nativeInfoGetOS',
		fallback: () =>
			// prettier-ignore
			/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
				? 'iOS'
				: /Android/.test(navigator.userAgent) && !window.MSStream
					? 'Android'
					: 'unkown',
	});
export const infoGetBluetoothMAC = () =>
	nativeMethodCall({
		method: 'nativeInfoGetBluetoothMAC',
		fallback: () => 'unkown',
	});
export const infoGetWifiMAC = () =>
	nativeMethodCall({
		method: 'nativeInfoGetWifiMAC',
		fallback: () => 'unkown',
	});
// v18 Bluetooth Perssion Handling
export const bluetoothEnable = () =>
	nativeMethodCall({
		method: 'nativeBluetoothEnable',
		fallback: () => window.nativeOnBluetoothEnable(BLUETOOTH_ENABLE_RESULT.notAvailable),
	});

export const bluetoothDoScan = yesno =>
	nativeMethodCall({
		method: 'nativeBluetoothDoScan',
		params: [isIOS() ? (yesno ? 1 : 0) : !!yesno],
	});

export const setBrightness = value =>
	nativeMethodCall({
		method: 'nativeSetBrightness',
		params: [value],
	});
export const audioIsHeadphonePlugged = () =>
	nativeMethodCall({
		method: 'nativeAudioIsHeadphonePlugged',
	});
export const appDoLog = logMessage =>
	nativeMethodCall({
		method: 'nativeAppDoLog',
		params: [logMessage],
		transform: () => true,
		fallback: logMessage => console.log('nativeLog: ' + logMessage),
	});
export const infoSetDeviceName = name =>
	nativeMethodCall({
		method: 'nativeInfoSetDeviceName',
		params: [name],
		fallback: () => false,
	});
export const infoGetOSVersion = () =>
	nativeMethodCall({
		method: 'nativeInfoGetOSVersion',
		fallback: () => 'unkown',
	});

export const locationEnable = () => {
	nativeMethodCall({
		method: 'nativeLocationEnable',
		fallback: () => 'unkown',
	});
};
